import React, { useEffect, useState } from "react";
import { Select, Card, Typography, Row, Col, Alert, Form } from "antd";
import PdfView from "../../../../components/custom/PDFView";
import { useDispatch } from "react-redux";
import { getData } from "../../../../actions/apiCall";
import moment from "moment";
import RenderFormItem from "../../../../components/Forms/FormItems";
import { constants } from "../../../../constants/common";
import { useSelector } from "react-redux";

const { Option } = Select;
const { Title, Text } = Typography;

const PayslipComponent: React.FC = () => {
    const [year, setYear] = useState<string>(null);
    const [month, setMonth] = useState<string>(null);
    const [paySlips, setPaySlips] = useState<any>(null);
    const [paySlipsMonth, setPaySlipsMonth] = useState<any>([]);
    const [paySlipUrl, setPaySlipUrl] = useState<string>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [userId, selectUserId] = useState(null)
    const { user } = useSelector((app: any) => app?.app)
    const dispatch = useDispatch();

    useEffect(() => {
        getPaySlips();
    }, [userId]);

    useEffect(() => {
        if (paySlips) {
            const selectedYear = paySlips.find((ele: any) => ele.year === year);
            if (selectedYear) {
                const months = selectedYear.months.map((ele: any) => moment(ele?.month, 'MM').format('MMMM'));
                setPaySlipsMonth(months);
            }
        }
    }, [year, paySlips]);

    useEffect(() => {
        if (year && month) {
            const selectedYear = paySlips.find((ele: any) => ele.year === year);
            if (selectedYear) {
                const selectedMonth = selectedYear.months.find((ele: any) => moment(ele?.month, 'MM').format('MMMM') === month);
                if (selectedMonth) {
                    setPaySlipUrl(selectedMonth.pdfUrl);
                }
            }
        }
    }, [year, month, paySlips]);

    const getPaySlips = async () => {
        setLoading(true);
        setPaySlips(null);
        try {
            const resData = await dispatch(getData('/finance/payslips', {
                userId
            }));
            if (resData.code === 200) {
                setPaySlips(resData.data);
                if (resData.data.length > 0) {
                    setYear(resData.data[0].year);
                }
            }

        } catch (error) {
            console.error("Error fetching pay slips:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            {user?.designation !== 'Admin' && !loading && !paySlips && <Title level={4}>No Pay Slips Available</Title>}
            {loading && <Title level={4}>Loading Pay Slips...</Title>}
            {(paySlips || user?.designation == 'Admin') && <Row gutter={16}>
                <Col span={6}>
                    <Card title="Pay Slips">
                        <Row gutter={16}>
                            {user?.designation == 'Admin' && <Col span={24}>
                                <Form
                                    layout="vertical"
                                >
                                    <RenderFormItem
                                        column={{
                                            name: 'user',
                                            type: 'select',
                                            isCombo: true,
                                            label: 'Select User',
                                            selectProps: {
                                                allowClear: true,
                                                showSearch: true,
                                                onChange: (e) => {
                                                    selectUserId(e)
                                                }
                                            }
                                        }}
                                        combo={[
                                            {
                                                name: 'user',
                                                api: '/users?enablePayroll=true',
                                                idKey: '_id',
                                                render: (e) => constants.GET_FULL_NAME(e)
                                            }
                                        ]}
                                    />
                                </Form>
                            </Col>}
                            <Col span={24}>
                                <Text>Select Year</Text>
                                <Select
                                    defaultValue={year}
                                    style={{ width: "100%", marginBottom: "10px" }}
                                    onChange={(value) => setYear(value)}
                                >
                                    {paySlips?.map(ele => <Option value={ele.year}>{ele.year}</Option>)}
                                </Select>
                            </Col>
                            <Col span={24}>
                                <Text>Select Month</Text>
                                <Select
                                    defaultValue={month}
                                    style={{ width: "100%", marginBottom: "10px" }}
                                    onChange={(value) => setMonth(value)}
                                >
                                    {paySlipsMonth?.map(ele => <Option value={ele}>{ele}</Option>)}
                                </Select>
                            </Col>
                            <Col span={24}>
                                <Alert type="warning" showIcon={true} message="Please note: Our team is currently working on the payroll module, and there may be some technical issues. Since payslip generation is part of the payroll process, there might be errors in your payslip. These issues will be fixed automatically later on. If you need to share your payslip with anyone outside the organization, please connect with your respective HR to confirm that the payslip you received is correct." />
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span={18}>
                    {!year || !month && <Card className="flex justify-center items-center">Select Year and Month to view Pay Slip</Card>}
                    {month && <Card title={`PAYSLIP ${month} - ${year}`} >
                        <div className="pdf-background">
                            <PdfView url={`${process.env.FILE_URL}${paySlipUrl}`} isToolbar={true} />
                        </div>
                    </Card>}
                </Col>
            </Row>}
        </div>
    );
};

export default PayslipComponent;
